import type * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

export type TypeParams = ec.models.TypeParams.WithDefaults<{
  entity: ents.core.mosaic.Widget
  createEntity: ents.core.mosaic.Widget.Input
  context: Context
}>

export type Context = ents.core.admin.Context.ForZone | undefined

/** Distinguishes widget selection in the page builder from other widget selection contexts. */
export const PAGE_BUILDER_SELECTION_TARGET: ec.models.Target =
  'builderSelectionTarget'
